import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { NzModalModule } from 'ng-zorro-antd/modal';
import { NzSpinModule } from 'ng-zorro-antd/spin';
import { SharedSafeHtmlPipeModule } from '../pipes/safe-html.module';
import { AnnouncementModalComponent } from './announcement-modal.component';

@NgModule({
  declarations: [
    AnnouncementModalComponent
  ],
  imports: [
    CommonModule,
    NzModalModule,
    NzSpinModule,
    SharedSafeHtmlPipeModule
  ],
  exports: [
    AnnouncementModalComponent
  ]
})
export class AnnouncementModalModule { }
